var _style, _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMicrosoftDynamics = function SvgMicrosoftDynamics(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.msDynamicsStyle0{fill-rule:evenodd;clip-rule:evenodd;fill:#F65314;}\r\n\t.msDynamicsStyle1{fill-rule:evenodd;clip-rule:evenodd;fill:#7FBB41;}\r\n\t.msDynamicsStyle2{fill-rule:evenodd;clip-rule:evenodd;fill:#00A1F1;}\r\n\t.msDynamicsStyle3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFBB00;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "msDynamicsStyle0 disabledStyle",
    d: "M4.5,4.8h43.1l0,43.1H4.5L4.5,4.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "msDynamicsStyle1 disabledStyle",
    d: "M51.9,4.8H95c0,14.4,0,28.7,0,43.1c-14.4,0-28.7,0-43.1,0C51.9,33.5,51.9,19.1,51.9,4.8L51.9,4.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "msDynamicsStyle2 disabledStyle",
    d: "M4.5,52.2c14.4,0,28.7,0,43.1,0c0,14.4,0,28.7,0,43.1H4.5L4.5,52.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "msDynamicsStyle3 disabledStyle",
    d: "M51.9,52.2c14.4,0,28.7,0,43.1,0v43.1H51.9C51.9,80.9,51.9,66.6,51.9,52.2z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftDynamics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoft_dynamics.86c46bc8.svg";
export { ForwardRef as ReactComponent };